import { Col, Form, Row } from "antd";
import React from "react";
import RadioGroup from "../../../../components/atoms/RadioGroup";
import Table from "../../../../components/atoms/Table";
import TimePicker from "../../../../components/atoms/TimePicker";
import ExplainWrapper from "../../../../components/molecures/ExplainWrapper";
import sharedConstants from "../../../../shared/constants";
import { BusinessDayType, DayOffDay } from "../../../../shared/enums";
import { isEveryDayRestSameArray } from "../../../../shared/options";
import { ValidationStatus } from "../../../Register/components/types";
import {
  getAlldayRestColumns,
  getWeekendWeekRestDayColumns,
  weekendRestDays,
  weekRestDays,
} from "../../constants";
import {
  AllDayBreakTime,
  DayOffTime,
  MakeDisabledTimeArgs,
  RenderInputProps,
  ReservationTime,
  TimeMode,
} from "../../Interface";
import { CustomTd, StyledRow, Wave } from "../../styles";
import {
  checkDuplicatedBreakTime,
  getStandardTime,
  makeDisabledTime,
} from "../../utils";
import MinusGhostButton from "../MinusGhostButton";
import PlusButtonRow from "../PlusButtonRow";
import PlusTimeTextButton from "../PlusTimeTextButton";

const { Item } = Form;
const RestTimeInputs: React.FC<RenderInputProps> = ({ form }) => {
  const isEveryDayRestSame: BusinessDayType = Form.useWatch(
    "isEveryDayRestSame",
    form
  );
  const notEveryDaySameRestTimeArray = Form.useWatch(
    "notEveryDaySameRestTimeArray",
    form
  );
  const everyDaySameRestTimeArray: DayOffTime[] = Form.useWatch(
    "everyDaySameRestTimeArray",
    form
  );
  const weekdayWeekendTimeArray: ReservationTime[] = Form.useWatch(
    "weekdayWeekendTimeArray",
    form
  );
  const alldayTimeArray: ReservationTime[] = Form.useWatch(
    "alldayTimeArray",
    form
  );
  const alldayBreakTimeArray: AllDayBreakTime[] = Form.useWatch(
    "alldayBreakTimeArray",
    form
  );

  const businessDayType = Form.useWatch("businessDayTypes", form);
  const startTime = Form.useWatch("startTime", form);
  const endTime = Form.useWatch("endTime", form);

  const fatestStartTime =
    businessDayType === BusinessDayType.EVERYDAY
      ? startTime
      : businessDayType === BusinessDayType.WEEKDAY_WEEKEND
      ? getStandardTime(
          [
            weekdayWeekendTimeArray[0]?.startTime,
            weekdayWeekendTimeArray[1]?.startTime,
          ],
          true
        )
      : getStandardTime(
          alldayTimeArray?.map((val) => val.startTime) || [],
          true
        );
  const latestEndTime =
    businessDayType === BusinessDayType.EVERYDAY
      ? endTime
      : businessDayType === BusinessDayType.WEEKDAY_WEEKEND
      ? getStandardTime([
          weekdayWeekendTimeArray[0]?.endTime,
          weekdayWeekendTimeArray[1]?.endTime,
        ])
      : getStandardTime(alldayTimeArray?.map((val) => val.endTime) || []);

  const makeColumnDisabledTime = () => {
    const weekendArray = alldayTimeArray?.filter(
      (val: ReservationTime) =>
        val.days?.includes(DayOffDay.SUNDAY) ||
        val.days?.includes(DayOffDay.SATURDAY)
    );
    const onlyWeekArray = alldayTimeArray?.filter((val: ReservationTime) => {
      return (
        val.days?.includes(DayOffDay.MONDAY) ||
        val.days?.includes(DayOffDay.TUESDAY) ||
        val.days?.includes(DayOffDay.WEDNESDAY) ||
        val.days?.includes(DayOffDay.THURSDAY) ||
        val.days?.includes(DayOffDay.FRIDAY)
      );
    });

    return (index: number) => ({
      fatestEndTime: undefined,
      latestStartTime: undefined,
      fatestStartTime:
        businessDayType === BusinessDayType.EVERYDAY
          ? startTime
          : businessDayType === BusinessDayType.WEEKDAY_WEEKEND
          ? weekdayWeekendTimeArray[index]?.startTime
          : getStandardTime(
              index === 0
                ? onlyWeekArray.map((val) => val.startTime) ||
                    alldayTimeArray.map((val) => val.startTime) ||
                    []
                : weekendArray.map((val) => val.startTime) ||
                    alldayTimeArray.map((val) => val.startTime) ||
                    [],
              true
            ),
      latestEndTime:
        businessDayType === BusinessDayType.EVERYDAY
          ? endTime
          : businessDayType === BusinessDayType.WEEKDAY_WEEKEND
          ? weekdayWeekendTimeArray[index]?.endTime
          : getStandardTime(
              index === 0
                ? onlyWeekArray.map((val) => val.endTime) ||
                    alldayTimeArray.map((val) => val.endTime) ||
                    []
                : weekendArray.map((val) => val.endTime) ||
                    alldayTimeArray.map((val) => val.endTime) ||
                    []
            ),
    });
  };

  const makeAllDayBreakTimeDisabledTime = (
    days: DayOffDay[]
  ): MakeDisabledTimeArgs => {
    switch (businessDayType) {
      case BusinessDayType.EVERYDAY:
        return {
          fatestEndTime: undefined,
          latestStartTime: undefined,
          fatestStartTime: startTime,

          latestEndTime: endTime,
        };
      case BusinessDayType.WEEKDAY_WEEKEND: {
        const hasWeek =
          days.filter((val) => weekRestDays.includes(val))?.length > 0;
        const hasWeekend =
          days.filter((val) => weekendRestDays.includes(val))?.length > 0;
        const startTimes = [];
        const endTimes = [];
        if (hasWeek) {
          startTimes.push(weekdayWeekendTimeArray[0]?.startTime);
          endTimes.push(weekdayWeekendTimeArray[0]?.endTime);
        }
        if (hasWeekend) {
          startTimes.push(weekdayWeekendTimeArray[1]?.startTime);
          endTimes.push(weekdayWeekendTimeArray[1]?.endTime);
        }

        return {
          fatestEndTime: undefined,
          latestStartTime: undefined,
          fatestStartTime: getStandardTime(startTimes, true),

          latestEndTime: getStandardTime(endTimes, false),
        };
      }
      case BusinessDayType.DAY: {
        const startTimes = [];
        const endTimes = [];
        for (let i = 0; i < days?.length; i += 1) {
          const nowDay = days[i];
          const businessTime =
            alldayTimeArray?.filter((val) => val.days?.includes(nowDay))
              .length > 0
              ? alldayTimeArray?.filter((val) => val.days?.includes(nowDay))[0]
              : undefined;

          if (businessTime) {
            startTimes.push(businessTime.startTime);
            endTimes.push(businessTime.endTime);
          }
        }

        return {
          fatestEndTime: undefined,
          latestStartTime: undefined,
          fatestStartTime: getStandardTime(startTimes, true),

          latestEndTime: getStandardTime(endTimes, false),
        };
      }
      default:
        return {
          latestEndTime: undefined,
          fatestStartTime: undefined,
          fatestEndTime: undefined,
          latestStartTime: undefined,
        };
    }
  };

  const disabledCheckboxValue = alldayBreakTimeArray?.reduce(
    (pre: string[], cur: AllDayBreakTime) => {
      if (cur.days)
        for (let i = 0; i < cur?.days?.length; i += 1) {
          if (!pre.includes(cur.days[i])) pre.push(cur.days[i]);
        }

      return pre;
    },
    []
  );
  return (
    <Row gutter={[0, 12]}>
      <Col span={24}>
        <Item noStyle name="isEveryDayRestSame">
          <RadioGroup options={isEveryDayRestSameArray} />
        </Item>
      </Col>
      <Col span={24}>
        <Item
          noStyle
          id="everyDaySameRestTimeArray"
          name="everyDaySameRestTimeArray"
          rules={[
            {
              validator: async (_, everyDaySameRestTimeArray: DayOffTime[]) => {
                if (isEveryDayRestSame === BusinessDayType.EVERYDAY)
                  for (
                    let i = 0;
                    i < everyDaySameRestTimeArray.length;
                    i += 1
                  ) {
                    const dayOffTime = everyDaySameRestTimeArray[i];
                    if (
                      fatestStartTime &&
                      latestEndTime &&
                      dayOffTime.endTime &&
                      dayOffTime.startTime
                    ) {
                      const checkDuplicate = checkDuplicatedBreakTime({
                        target: dayOffTime,
                        times: [
                          ...everyDaySameRestTimeArray.filter(
                            (val, arrayIdx) => arrayIdx !== i
                          ),
                          {
                            startTime: fatestStartTime,
                            endTime: latestEndTime,
                          },
                        ],
                      });

                      if (checkDuplicate.status === "error")
                        return Promise.reject(
                          new Error(checkDuplicate.explain)
                        );
                    }
                    if (
                      (!dayOffTime.endTime && dayOffTime.startTime) ||
                      (!dayOffTime.startTime && dayOffTime.endTime)
                    )
                      return Promise.reject(
                        new Error(
                          sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                        )
                      );
                  }
                return Promise.resolve();
              },
            },
          ]}
        />{" "}
        <Item noStyle name="alldayBreakTimeArray" id="alldayBreakTimeArray" />
        <Item noStyle name="repairShopBusinessBreakTimes" />
        {isEveryDayRestSame ? (
          isEveryDayRestSame === BusinessDayType.EVERYDAY ? (
            <Row gutter={[0, 12]}>
              {everyDaySameRestTimeArray?.map(
                (dayOffTime: DayOffTime, timeIndex: number) => {
                  const checkDuplicated = checkDuplicatedBreakTime({
                    target: everyDaySameRestTimeArray[timeIndex],
                    times: [
                      ...everyDaySameRestTimeArray.filter(
                        (val, arrayIndex) => arrayIndex !== timeIndex
                      ),
                      { startTime: fatestStartTime, endTime: latestEndTime },
                    ],
                  });
                  const getStatus = (): ValidationStatus => {
                    if (checkDuplicated.status === "error")
                      return checkDuplicated;
                    if (
                      (dayOffTime.endTime && !dayOffTime.startTime) ||
                      (dayOffTime.startTime && !dayOffTime.endTime)
                    )
                      return {
                        status: "error",
                        explain:
                          sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED,
                      };
                    return {
                      status: undefined,
                      explain: undefined,
                    };
                  };
                  return (
                    <Col span={24} key={timeIndex}>
                      <ExplainWrapper status={getStatus()}>
                        <StyledRow gutter={[12, 0]}>
                          <Col flex="0 0 200px">
                            <TimePicker
                              value={dayOffTime.startTime}
                              popupStyle={{
                                minWidth: "calc(200px - 20px)",
                              }}
                              status={getStatus().status ? "error" : undefined}
                              onOk={(selectedTime) => {
                                const newArray = [...everyDaySameRestTimeArray];
                                newArray[timeIndex].startTime = selectedTime;

                                form.setFieldsValue({
                                  everyDaySameRestTimeArray: newArray,
                                });
                              }}
                              disabledTime={() =>
                                makeDisabledTime({
                                  fatestStartTime,
                                  latestEndTime,
                                  latestStartTime: dayOffTime.startTime,
                                  fatestEndTime: dayOffTime.endTime,
                                  disabledTimes: everyDaySameRestTimeArray,
                                })
                              }
                              endHour={dayOffTime.endTime?.hours()}
                              type={TimeMode.START}
                            />
                          </Col>

                          <Wave />
                          <Col flex="0 0 200px">
                            <TimePicker
                              value={dayOffTime.endTime}
                              popupStyle={{
                                width: "calc(200px - 20px)",
                              }}
                              status={getStatus().status ? "error" : undefined}
                              onOk={(selectedTime) => {
                                const newArray = [...everyDaySameRestTimeArray];
                                newArray[timeIndex].endTime = selectedTime;

                                form.setFieldsValue({
                                  everyDaySameRestTimeArray: newArray,
                                });
                              }}
                              disabledTime={() =>
                                makeDisabledTime({
                                  fatestStartTime,
                                  latestEndTime,
                                  latestStartTime: dayOffTime.startTime,
                                  fatestEndTime: dayOffTime.endTime,
                                  disabledTimes: everyDaySameRestTimeArray,
                                  mode: TimeMode.END,
                                })
                              }
                              startHour={dayOffTime.startTime?.hours()}
                              type={TimeMode.END}
                            />
                          </Col>
                          <Col>
                            {everyDaySameRestTimeArray?.length > 0 && (
                              <MinusGhostButton
                                onClick={() => {
                                  const newArray = [
                                    ...everyDaySameRestTimeArray,
                                  ].filter((val, index) => index !== timeIndex);
                                  form.setFieldsValue({
                                    everyDaySameRestTimeArray: newArray,
                                  });
                                }}
                              />
                            )}
                          </Col>
                        </StyledRow>
                      </ExplainWrapper>
                    </Col>
                  );
                }
              )}
              <Col span={24}>
                <PlusTimeTextButton
                  arrayLength={
                    form.getFieldValue("everyDaySameRestTimeArray")?.length
                  }
                  onClick={() => {
                    const newArray = [...everyDaySameRestTimeArray];
                    const newTime: DayOffTime = {
                      startTime: undefined,
                      endTime: undefined,
                    };
                    form.setFieldsValue({
                      everyDaySameRestTimeArray: [...newArray, newTime],
                    });
                  }}
                />
              </Col>
            </Row>
          ) : isEveryDayRestSame === BusinessDayType.WEEKDAY_WEEKEND ? (
            <>
              <Item
                noStyle
                name="notEveryDaySameRestTimeArray"
                id="notEveryDaySameRestTimeArray"
              />
              <Table
                components={{
                  body: {
                    cell: (props: any) => <CustomTd>{props.children}</CustomTd>,
                  },
                }}
                columns={getWeekendWeekRestDayColumns(
                  form,
                  makeColumnDisabledTime()
                )}
                dataSource={notEveryDaySameRestTimeArray}
                pagination={false}
                rowKey="day"
              />
            </>
          ) : (
            <>
              <Table
                components={{
                  body: {
                    cell: (props: any) => (
                      <CustomTd
                        colSpan={alldayBreakTimeArray?.length === 0 ? 4 : 1}
                      >
                        {props.children}
                      </CustomTd>
                    ),
                  },
                }}
                columns={
                  form
                    ? getAlldayRestColumns(
                        form,
                        makeAllDayBreakTimeDisabledTime
                      )
                    : []
                }
                dataSource={alldayBreakTimeArray?.map((val, index) => ({
                  ...val,
                  id: index,
                }))}
                pagination={false}
                rowKey="id"
              />
              <PlusButtonRow
                disabled={
                  disabledCheckboxValue?.length >= 7 ||
                  alldayBreakTimeArray.length >= 7
                }
                onClick={() => {
                  const newArray = [...alldayBreakTimeArray];

                  const newEle: AllDayBreakTime = {
                    days: [],
                    breakTimes: [
                      {
                        startBreakTime: undefined,
                        endBreakTime: undefined,
                      },
                    ],
                  };
                  form.setFieldsValue({
                    alldayBreakTimeArray: [...newArray, newEle],
                  });
                }}
              />
            </>
          )
        ) : null}
      </Col>
    </Row>
  );
};

export default RestTimeInputs;
